var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"testimonial"},[(_vm.quote)?_c('div',{staticClass:"testimonial__quote"},[_vm._v("“")]):_vm._e(),_c('div',{staticClass:"testimonial__wrapper"},[_c('blockquote',{staticClass:"mb-4"},[_vm._t("default")],2),_c('cite',[_c('p',{staticClass:"mb-0"},[_c('strong',[_vm._t("name")],2)]),_c('p',[_vm._t("extra")],2)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }